import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ApiRequestService } from 'src/app/shared/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class UserMessagesService {

  unread_messages_count: number = 0;

  constructor(
    private app: AppService,
    private api: ApiRequestService
  ) { }

  getMessagesMeta() {
    // A background request: the badge refresh is never triggered by a user action, so a failure to
    // reach the server must not open a modal.
    this.api.makeRequest('get', 'v2/user/messages/meta', {}, {}, {}, false, true)
    .then((response: {
      unread_messages_count: number
    }) => {
      this.unread_messages_count = response.unread_messages_count
    })
    .catch((): void => {
      // The badge is an aid, not a function. Keep the last known count.
    });
  }
}


